<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver"><i class="fa fa-chevron-left"></i></button>
        <button class="btn btn-outline-success" (click)="onNext()" title="Aceptar" [disabled]="isDisabled">Aceptar</button>
    </form>
</nav>

<form [formGroup]="form" class="container-fluid" autocomplete="off">
    <div class="animated fadeIn">
        <h4>Nueva Solicitud</h4>
        <label class="col-form-label">Seleccione el tipo de solicitud y pulse el botón de "Aceptar"</label>

        <div class="row">
            <div class="col-md-12">

                <div class="card card-accent-success animated fadeIn">
                    <a class="card-header-a" (click)="isCollapsedTipos = !isCollapsedTipos" [attr.aria-expanded]="!isCollapsedTipos" aria-controls="collapseExample">
                        <div class="card-header-buscador">
                            <i class="fa fa-filter"></i> Tipo de Solicitud
                        </div>
                    </a>
                    <div class="card-body-detalle">
                        <div class="row">
                            <div class="col-md-6 collapse group-campos" id="collapseTipos" [ngbCollapse]="isCollapsedTipos">

                                <div *ngIf="!listTipoSolicitudEx">
                                    <p-progressSpinner class="p-progress-spinner-circle"></p-progressSpinner>
                                </div>
                                <div class="ui-g">
                                    <ng-container *ngFor="let item of listTipoSolicitudEx">
                                        <div class="ui-g-12" (click)="onSelectedTipoSolicitudEx(item.Codigo)">
                                            <p-radioButton formControlName="tipoSolicitudEx" (click)="onSelectedTipoSolicitudEx()" inputStyleClass="form-control" name="tipoSolicitudEx" [value]="item.Codigo"></p-radioButton>
                                            <label [for]="item.Codigo" class="cursor-hand ml-2">
                                                <img src="/assets/images/TipoSolicitudEx/{{item.Id}}.png" class="ps-1" style="width:32px; vertical-align: top;" />
                                                <span style="vertical-align:middle; margin-left: .2em">{{item.Descripcion}}</span>
                                            </label>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">

                <div *ngIf="form.value.tipoSolicitudEx === 'T' || form.value.tipoSolicitudEx === 'R' || form.value.tipoSolicitudEx === 'A' || form.value.tipoSolicitudEx === 'C' || form.value.tipoSolicitudEx === 'CE'">
                    <!--Tercer País, Reexportación o Atestación Seleccionado-->
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedDatosTercerPais = !isCollapsedDatosTercerPais" [attr.aria-expanded]="!isCollapsedDatosTercerPais" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-filter"></i> Datos adicionales
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-campos" id="collapsedDatosTercerPais" [ngbCollapse]="isCollapsedDatosTercerPais">
                                <div class="row">
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="intEstado">Punto de Inspección</label>
                                        <ng-select [items]="listPuntoInspeccion"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdPuntoInspeccion"
                                                   loadingText="Cargando..."
                                                   [loading]="!listPuntoInspeccion"
                                                   notFoundText="Punto de Inspección no encontrado"
                                                   placeholder="-- Seleccione un Punto de Inspección --"
                                                   clearAllText="Eliminar selección"
                                                   [ngClass]="displayFieldCssNgSelect('IdPuntoInspeccion')"
                                                   (change)="onSelectPuntoInspeccion()">
                                        </ng-select>


                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPuntoInspeccion','required')">
                                            Punto de Inspección es obligatorio
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="inpPais">País Destino</label>
                                        <ng-select [items]="listPais"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"                                                   
                                                   formControlName="IdPaisDestino"
                                                   loadingText="Cargando..."
                                                   [loading]="!listPais"
                                                   notFoundText="País no encontrado"
                                                   placeholder="-- Seleccione un País --"
                                                   [ngClass]="displayFieldCssNgSelect('IdPaisDestino')"
                                                   (change)="onSelectPaisDestino()"
                                                   clearAllText="Eliminar selección">
                                        </ng-select>


                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPaisDestino','required')">
                                            País es obligatorio
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="inpPais">Idioma Certificado</label>
                                        <ng-select [items]="listIdioma"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"                                                   
                                                   formControlName="IdIdioma"
                                                   loadingText="Cargando..."
                                                   [loading]="!listIdioma"
                                                   notFoundText="Idioma no encontrado"
                                                   placeholder="-- Seleccione un Idioma --"
                                                   [ngClass]="displayFieldCssNgSelect('IdIdioma')"
                                                   (change)="onSelectIdioma()"
                                                   clearAllText="Eliminar selección">
                                        </ng-select>


                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdIdioma','required')">
                                            Idioma es obligatorio
                                        </div>
                                    </div>

                                </div>

                                <div class="row">
                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" [ngClass]="{ 'required-field' : campoUbicacion }" for="">Ubicación</label>
                                        <ng-select [items]="listUbicacion"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdUbicacion"
                                                   loadingText="Cargando..."
                                                   [loading]="(!listUbicacion && (form.value.IdPuntoInspeccion > 0))"
                                                   notFoundText="Ubicación no encontrada"
                                                   placeholder="-- Seleccione Ubicación o Instalación Autorizada --"
                                                   [ngClass]="displayFieldCssNgSelect('IdUbicacion')"
                                                   clearAllText="Eliminar selección"
                                                   (change)="onSelectUbicacion()">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdUbicacion','required')">
                                            Ubicación o Instalación Autorizada son obligatorias
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label" [ngClass]="{ 'required-field' : campoInstalacion }" for="">Instalación Autorizada</label>
                                        <ng-select [items]="listInstalacionAutorizada"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdInstalacionAutorizada"
                                                   loadingText="Cargando..."
                                                   [loading]="(!listInstalacionAutorizada && (form.value.IdPuntoInspeccion > 0))"
                                                   notFoundText="Instalación Autorizada no encontrada"
                                                   placeholder="-- Seleccione Ubicación o Instalación Autorizada --"
                                                   [ngClass]="displayFieldCssNgSelect('IdInstalacionAutorizada')"
                                                   clearAllText="Eliminar selección"
                                                   (change)="onSelectInstalacionAutorizada()">
                                        </ng-select>

                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdInstalacionAutorizada','required')">
                                            Instalación Autorizada o Ubicación son obligatorias
                                        </div>
                                    </div>

                                    <div class="form-group col-md-2">
                                        <label class="col-form-label" for="">Previa</label>
                                            <p-toggleButton class="form-control-togglebutton" formControlName="esPrevia" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" offIcon="pi pi-times"></p-toggleButton>
                                    </div>

                                    <div *ngIf="form.value.tipoSolicitudEx === 'T' || form.value.tipoSolicitudEx === 'R' || form.value.tipoSolicitudEx === 'C'" class="form-group col-md-2">
                                        <label class="col-form-label" for="">Atestación Fitosanitaria</label>
                                        <p-toggleButton class="form-control-togglebutton" formControlName="esAtestacionFitosanitaria" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                                                        offIcon="pi pi-times" (click)="resetAtestFito()"></p-toggleButton>
                                    </div>
                                </div>
                                <!--CAMPAÑAS ESPECÍFICAS-->
                                <div class="row" *ngIf="form.value.tipoSolicitudEx === 'CE'">

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="IdCampania">Campaña</label>
                                        <ng-select appendTo="body"
                                                   loadingText="Cargando..."
                                                   [items]="listCampania"
                                                   [readonly]="!listCampania || listCampania.length === 0"
                                                   bindLabel="Descripcion"
                                                   bindValue="Id"
                                                   formControlName="IdCampania"
                                                   [loading]="listCampania === null"
                                                   placeholder="-- Seleccione una Campaña --"
                                                   [ngClass]="displayFieldCssNgSelect('IdCampania')"
                                                   (change)="onSelectCampania()"
                                                   notFoundText="Campaña no encontrada"
                                                   clearAllText="Eliminar selección">
                                            <ng-template ng-option-tmp let-item="item">
                                                <div container="body" ngbTooltip="{{ item.Descripcion }}">{{ item.Descripcion }}</div>
                                            </ng-template>
                                        </ng-select>
                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdCampania','required')">
                                            Campaña es obligatoria
                                        </div>
                                    </div>

                                    <div class="form-group col-md-4">
                                        <label class="col-form-label required-field" for="IdPeriodo">Periodo</label>
                                        <ng-select appendTo="body"
                                                   loadingText="Cargando..."
                                                   [items]="listPeriodo"
                                                   [readonly]="!listPeriodo || listPeriodo.length === 0"
                                                   bindLabel="DescripcionPeriodo"
                                                   bindValue="Id"
                                                   formControlName="IdPeriodo"
                                                   [loading]="listPeriodo === null && form.value.IdCampania !== null"
                                                   placeholder="-- Seleccione un Periodo --"
                                                   [ngClass]="displayFieldCssNgSelect('IdPeriodo')"
                                                   (change)="onSelectPeriodo()"
                                                   notFoundText="Periodo no encontrado"
                                                   clearAllText="Eliminar selección">
                                            <ng-template ng-option-tmp let-item="item">
                                                <div container="body" ngbTooltip="{{ item.DescripcionPeriodo }}">{{ item.DescripcionPeriodo }}</div>
                                            </ng-template>
                                        </ng-select>
                                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdPeriodo','required')">
                                            Periodo es obligatorio
                                        </div>
                                        <div class="invalid-feedback tip d-block">
                                            <label>(Depende de la "Campaña")</label>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="mostrarAtestacionesFitosanitarias === true">
                    <!--Atestación Fitosanitaria Seleccionado-->
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedAtestacionFitosanitaria = !isCollapsedAtestacionFitosanitaria" [attr.aria-expanded]="!isCollapsedAtestacionFitosanitaria" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-filter"></i> Datos atestación fitosanitaria
                            </div>
                        </a>
                        <div class="card-body-detalle">
                            <div class="collapse group-campos" id="collapsedAtestacionFitosanitaria" [ngbCollapse]="isCollapsedAtestacionFitosanitaria">
                                <div class="row" style="margin-bottom: 10px;">
                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="">Ref. Atestación Fito</label>
                                        <div class="input-group">
                                            <input formControlName="RefAtestFito" name="" title="" maxlength="11" class="form-control" id="inpNombre" type="text" value="">

                                        </div>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="">PIN</label>
                                        <div class="input-group">
                                            <input formControlName="Pin" name="" numbersOnly title="" maxlength="6" class="form-control" id="inpNombre" type="text" value="">
                                            <span class="input-group-btn">
                                                &nbsp;<button name="btnSearchSolicitudAtestFito" class="btn btn-list btn-secondary" type="button" title="Buscar solicitud de atestación fitosanitaria" (click)="onSearchSolicitudAtestFito()"><i class="fa fa-search"></i></button>
                                            </span>
                                        </div>
                                    </div>

                                    <!--Mensaje de atestación no encontrada-->
                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="" style="margin-top: 35px;">
                                            <span>{{mensajeAtestacion}}</span>
                                        </label>
                                    </div>
                                </div>
                                 
                                <!--GRID-->
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="card card-accent-success animated fadeIn" style="margin-bottom: 0.2rem !important;">
                                            <a class="card-header-a">
                                                <div class="card-header-buscador">
                                                    <i class="fa fa-list"></i> Listado de Atestaciones Fitosanitarias
                                                </div>
                                            </a>

                                            <div class="card-body-grid">

                                                <p-table #tableSearch autoLayout="true" [value]="atestFitoCollection"
                                                         [columns]="colsAtestaciones" sortField="RefAtestFito" sortOrder="-1"
                                                         styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                                         [ngClass]="displayGridHidden(atestFitoCollection)">

                                                    <ng-template pTemplate="header" let-columns>
                                                        <tr>
                                                            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                                                {{col.header}}
                                                                <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                                            </th>
                                                        </tr>
                                                    </ng-template>
                                                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                                        <tr>

                                                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                                                <span *ngIf="(col.field!=='Link')">
                                                                    {{rowData[col.field]}}
                                                                </span>                                                                

                                                                <div *ngIf="col.field==='Link'" class="btn-group">

                                                                    <button (click)="onDeleteAtestacion(rowData)" type="button"
                                                                            class="btn btn-sm btn-danger">
                                                                        <span class="fa fa-remove"></span>
                                                                    </button>

                                                                </div>
                                                            </td>
                                                        </tr>

                                                    </ng-template>
                                                </p-table>
                                                <div *ngIf="numeroAtestaciones === 0" class="empty-grid">
                                                    No hay atestaciones añadidas a la lista
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                <div *ngIf="form.value.tipoSolicitudEx === 'AS'">
                    <!--Anulación y Sustitución Seleccionado-->
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedAnulacionSustitucion = !isCollapsedAnulacionSustitucion" [attr.aria-expanded]="!isCollapsedAnulacionSustitucion" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-filter"></i> Datos adicionales
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-campos" id="collapsedAnulacionSustitucion" [ngbCollapse]="isCollapsedAnulacionSustitucion">
                                <div class="row">
                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="">Nº Solicitud</label>
                                        <div class="input-group">
                                            <input formControlName="CodigoSolicitud" name="" title="" maxlength="12" class="form-control" id="inpNombre" type="text" value="">
                                            <span class="input-group-btn">
                                                &nbsp;<button name="btnSearchSolicitud" class="btn btn-list btn-secondary" type="button" title="Buscar solicitud por Nº Solicitud" (click)="onSearchSolicitudByCodigo()"><i class="fa fa-search"></i></button>
                                            </span>
                                        </div>
                                    </div>

                                    <div class="form-group col-md-3">
                                        <label class="col-form-label" for="">Nº Certificado</label>
                                        <div class="input-group">
                                            <input formControlName="NumeroCertificado" name="" title="" maxlength="50" class="form-control" id="inpNombre" type="text" value="">
                                            <span class="input-group-btn">
                                                &nbsp;<button name="btnSearchSolicitud" class="btn btn-list btn-secondary" type="button" title="Buscar solicitud por Nº Certificado" (click)="onSearchSolicitudByNumeroCertificado()"><i class="fa fa-search"></i></button>
                                            </span>
                                        </div>
                                    </div>

                                    <!--Mensaje de éxito-->
                                    <div *ngIf="NumeroCertificado !== ''" class="form-group col-md-6">
                                        <label class="col-form-label" for="">
                                            <span>{{mensajeExito1}}</span>
                                            <b><span>{{NumeroCertificado}}</span></b>
                                            <span>{{mensajeExito2}}</span>
                                        </label>

                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <!--Validaciones propias de la solicitud-->
                                        <table *ngIf="validacionCollection !== null && validacionCollection.length > 0" class="table table-responsive table-sm">
                                            <tbody>
                                                <tr *ngFor="let item of validacionCollection">
                                                    <td class="empty-grid">{{item}}</td>
                                                </tr>
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card-body-detalle">
                    <!--<div class="form-group">
                    <label class="col-form-label" for="inpHabilitado">Importador No Nacional</label>
                    <p-toggleButton class="form-control-togglebutton" formControlName="esNifExtranjero" onLabel="Sí" offLabel="NO" onIcon="pi pi-check"
                        offIcon="pi pi-times"></p-toggleButton>
                    </div>-->
                </div>

            </div>
        </div>
    </div>

</form>
